import { ResolveFn } from '@angular/router';
import { AccountRoutingRouteNames } from '@pxl/route-names';

export const onlineCheckInResolver: ResolveFn<boolean> = (route, state) => {
    const url = state.url;
    return (
        url.includes(AccountRoutingRouteNames.OnlineCheckInStart) ||
        url.includes(AccountRoutingRouteNames.OnlineCheckInWithRegistrationSuccess)
    );
};
